
import styles from "./Profile.module.scss"
import sortIcon from "../../resources/images/sort.svg";
import { useEffect, useState } from "react";
import Loader from "../common/Loader/Loader";
import DataTable from "react-data-table-component";
import tableCustomStyles from "../common/CustomeStyle";
import ActionMenu from "../common/ActionMenu/ActionMenu";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { masterDataActions } from "../../actions/masterData.action";
import useModal from "../Hooks/useModal";
import ModalDialog from "../common/Modal/Modal";
import UpdateMasterForm from "../MasterDataForm/UpdatemasterDataForm";
import * as yup from "yup";
import Form from "../common/Form/From";
import ConfirmDialog from "../common/ConfirmDialog/ConfirmDialog";
import { BsExclamation } from "react-icons/bs";
import { formatMoney } from "../../helpers";
import NoDataFond from "../common/noDatafound/noDataPage";
const ProfileComponent = (props) => {
    const { toggle: updateMasterDataToggle, visible: updateMasterVisible } = useModal();
    let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
    const [sort, setSort] = useState("id");
    const [sortType, setSortType] = useState("desc");
    const [dsort, setDsort] = useState("id");
    const [dsortType, setDsortType] = useState("desc");
    const [pending, setPending] = useState(true)
    const [editedData, setEditedData] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [activeRow, setActiveRow] = useState("");
    const [activeDeptId, setActiveDeptId] = useState(null);
    const [initialValues, setInitialValues] = useState({
        name: "",
        type: "",
        parentId: "",
        description: "",
        min_salary: "",
        max_salary: ""
    });
    const [designationData, setDesignationData] = useState([])
    const dispatch = useDispatch()
    const departmentment = useSelector((state) => state.masterData.department);
    const designation = useSelector((state) => state.masterData.designation);
    const [dataNotFound, setdataNotFound] = useState(false)

    useEffect(() => {
        setDesignationData(designation)
    }, [designation])

    useEffect(() => {
        if (departmentment && departmentment.length > 0) {
            setActiveDeptId(departmentment[0].id)
            setdataNotFound(false)
        } else if (departmentment?.length == 0) {
            setdataNotFound(true)
        }

    }, [departmentment])

    useEffect(() => {
        if (ConfirmModal === false) {
            setDeleteId(null)
        }
    }, [ConfirmModal])


    useEffect(() => {
        const querys = getRequestDepartmentParams(dsort, dsortType)
        dispatch(masterDataActions.getDepartments(querys))
    }, [dsort, dsortType])

    useEffect(() => {
        if (activeDeptId) {
            const query = getRequestParams(sort, sortType)
            dispatch(masterDataActions.getDesignationBydepartment(activeDeptId, query))
            setTimeout(() => {
                setPending(false)
            }, 500);

        }
    }, [activeDeptId, sort, sortType])

    const getRequestParams = (
        sort,
        sortType,
    ) => {
        let params = {};
        if (sort) {
            params["sort"] = sort;
        }

        if (sortType) {
            params["sort_type"] = sortType;
        }

        return params;
    };

    const getRequestDepartmentParams = (
        sort,
        sortType,
    ) => {
        let params = {};
        if (sort) {
            params["sort"] = sort;
        }

        if (sortType) {
            params["sort_type"] = sortType;
        }

        return params;
    };

    useEffect(() => {
        if (editedData !== null && editedData?.id) {
            if (editedData?.type === "designation") {
                setInitialValues({
                    name: editedData?.name,
                    type: editedData?.type,
                    parentId: editedData?.parentId,
                    min_salary: editedData?.min_salary,
                    max_salary: editedData?.max_salary,
                    description: editedData?.description
                })
            } else {
                setInitialValues({
                    name: editedData?.name,
                    type: editedData?.type
                })
            }

            updateMasterDataToggle()
        }
    }, [editedData])

    useEffect(() => {
        if (!updateMasterVisible) {
            setEditedData(null)
        }
    }, [updateMasterVisible])

    const onRadioChange = (deptId) => {
        setPending(true)
        setActiveDeptId(deptId)
    }

    const departmentColumn = [
        {
            name: "Department",
            selector: (row) => (
                <div className={`radio-part ${activeDeptId === row?.id ? 'activePart' : ''}`}>
                    <div className="radio-main-part" onClick={() => {
                        const myBtn = document.getElementById(`departmentRadio_${row?.id}`)
                        myBtn.click()
                        setPending(true)
                    }}>
                        <input
                            type="radio"
                            name="departmentRadio"
                            id={`departmentRadio_${row?.id}`}
                            value={row?.id}
                            onChange={(e) => onRadioChange(row?.id)}
                            checked={activeDeptId === row?.id ? true : false}
                        />
                        {row?.name}
                    </div>
                    <div className="ActionMenuPart">
                        <ActionMenu
                            size="small"
                            row={row}
                            setEditedData={setEditedData}
                            setDeleteId={setDeleteId}
                            setActiveRow={setActiveRow}
                        />
                    </div>

                </div>
            ),
            sortable: true,
            sortField: "name",
            allowOverflow: true,
            grow: 2,
            style: {
                cursor: "pointer",
            },
        },
    ]

    const designationColumn = [
        {
            name: "Designation",
            selector: (row) => row?.name,
            sortable: true,
            sortField: "name",
            style: {
                cursor: "default",
            },
        },
        {
            name: "CTC Range",
            selector: (row) => (
                <div className="budgetColumn">
                    {formatMoney(row.min_salary) == 0 && formatMoney(row.max_salary) == 0
                        ? "  "
                        : formatMoney(row.min_salary) + " - " + formatMoney(row.max_salary)}
                </div>
            ),
            sortable: true,
            sortField: "min_salary",
            style: {
                cursor: "default",
            },
        },
        {
            name: "Description",
            selector: (row) => <div className="descriptionMainPart" title={row?.description}>{row?.description}</div>,
            sortable: true,
            sortField: "description",
            style: {
                cursor: "default",
            },
        },
        {
            cell: (row) => (
                <ActionMenu
                    size="small"
                    row={row}
                    setEditedData={setEditedData}
                    setDeleteId={setDeleteId}
                    setActiveRow={setActiveRow}
                />
            ),
            allowOverflow: true,
            width: "56px",
        },

    ]

    const handleSort = async (column, sortDirection) => {
        if (column?.sortField) {
            setSort(column?.sortField);
            setSortType(sortDirection);
        }
    };

    const handleDepartmentSort = async (column, sortDirection) => {
        if (column?.sortField) {
            setDsort(column?.sortField);
            setDsortType(sortDirection);
        }
    };

    useEffect(() => {
        if (deleteId !== null) {
            ConfirmToggle();
        }
    }, [deleteId]);

    const deleteMasterData = (id) => {
        if (id) {
            if (activeRow && activeRow.id) {
                dispatch(masterDataActions.deleteMasterData(id, `type=${activeRow?.type}`));
            }
            setTimeout(() => {
                if (activeRow && activeRow.id) {
                    if (activeRow.parentId) {
                        dispatch(masterDataActions.getDesignationBydepartment(activeRow.parentId))
                    } else {
                        dispatch(masterDataActions.getDepartments())

                    }
                }
                setDeleteId(null)
                setActiveRow(null)

            }, 100)

            ConfirmToggle();
        }
    };

    const handleSubmit = (values) => {
        if (values && editedData !== null) {
            dispatch(masterDataActions.updateMasterData(values, editedData?.id)).then((res) => {
                if (res) {
                    if (values?.parentId && values.parentId !== "") {
                        dispatch(masterDataActions.getDesignationBydepartment(values.parentId))
                    } else {
                        dispatch(masterDataActions.getDepartments())

                    }
                    updateMasterDataToggle()
                }
            })
        }
    }

    const renderForm = (errors, touched) => {
        return (
            <UpdateMasterForm
                errors={errors}
                touched={touched}
                editedData={editedData}
            />
        );
    };


    const masterSchema = yup.object().shape({
        type: yup.string().required("Type is required"),
        name: yup.string().required("Required"),
    });
    
    return (
        <div className={styles.profileMain}>
            {
                dataNotFound ? (<NoDataFond />) : (
                <Row>
                    <Col md="2" className={`${styles.deptTabPart}`}>
                        <div className={`${styles.departmentTable} departmentTable`}>
                            <DataTable
                                columns={departmentColumn}
                                data={departmentment}
                                customStyles={tableCustomStyles}
                                highlightOnHover
                                pointerOnHover
                                // progressPending={pending}
                                progressComponent={
                                    <Loader height={50} width={50} color={"#5382ba"} center={true} />
                                }
                                onSort={handleDepartmentSort}
                                sortServer
                                persistTableHead
                                responsive
                                fixedHeader
                                fixedHeaderScrollHeight="70vh"
                                sortIcon={<img src={sortIcon} alt="sort" />}
                            />
                        </div>
                    </Col>
                    <Col md="10" className={`${styles.skillsTabPart}`}>
                        <div className={`${styles.skillsTable} skillsTable`}>
                            <DataTable
                                columns={designationColumn}
                                data={designationData}
                                customStyles={tableCustomStyles}
                                highlightOnHover
                                pointerOnHover
                                progressPending={pending}
                                progressComponent={
                                    <Loader height={50} width={50} color={"#5382ba"} center={true} />
                                }
                                onSort={handleSort}
                                sortServer
                                persistTableHead
                                responsive
                                fixedHeader
                                fixedHeaderScrollHeight="70vh"
                                sortIcon={<img src={sortIcon} alt="sort" />}
                                noDataComponent={<div><NoDataFond /></div>}
                            />
                        </div>
                    </Col>
                </Row>)
            }

            <ModalDialog
                toggle={updateMasterDataToggle}
                title={`${editedData !== null ? "Update" : "Add"} Master Data`}
                visible={updateMasterVisible}
                size="md"
                bodyClass="p-0"
            >
                <Form
                    initialValues={initialValues}
                    validationSchema={masterSchema}
                    handleSubmit={handleSubmit}
                    renderForm={renderForm}
                />
            </ModalDialog>

            <ConfirmDialog
                visible={ConfirmModal}
                toggle={ConfirmToggle}
                title="Are you sure you want to delete?"
                activeBtnClick={() => {
                    deleteMasterData(deleteId);
                }}
            >
                <div className={`confirmIcon rounded-circle`}>
                    <BsExclamation style={{ fontSize: 42 }} />
                </div>
            </ConfirmDialog>

        </div>
    )
}

export default ProfileComponent;